import { Component, Output, EventEmitter, ViewChild, Input } from '@angular/core';

@Component({
  selector: 'rmt-chips',
  templateUrl: 'rmt-chips.html'
})
export class RmtChipsComponent {
  @Input() chipsList;
  @Input() selectedChip;
  @Output() onChipSelect = new EventEmitter<any>(); 

  constructor() {
    
  }
  ionViewDidLoad() {
   if(!this.selectedChip)
      this.selectedChip = this.chipsList[0];
   

  }
  onItemClick(chipItem){
    this.chipsList.forEach((item) => {
      item.isSelected = false;
    });
    chipItem.isSelected = true;
    this.selectedChip = chipItem;
    if(this.onChipSelect){
      this.onChipSelect.emit(chipItem);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-chips/rmt-chips.ts